import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Skills from "./scenes/skills";
import Coaches from "./scenes/coaches";
import TrainingProgramBuilder from "./scenes/trainingprogrambuilder";
import ContentLibrary from "./scenes/contentlibrary";
import Clients from "./scenes/clients";
import CoachingSessions from "./scenes/coachingsessions";
import CoachingSessionsByStatus from "./scenes/coachingsessions/indexByStatus";
import CoachingSessionsByFrequency from "./scenes/coachingsessions/indexByFrequency";
import Tasks from "./scenes/tasks";
import TasksByStatus from "./scenes/tasks/indexByStatus";
import TasksByPriority from "./scenes/tasks/indexByPriority";
import GoalSettingAndTracking from "./scenes/goalsettingandtracking";
import GoalSettingAndTrackingByStatus from "./scenes/goalsettingandtracking/indexByStatus";
import GoalSettingAndTrackingByPriority from "./scenes/goalsettingandtracking/indexByPriority";
import CoachPerformanceTracking from "./scenes/coachperformancetracking";
import Billing from "./scenes/billing";
import BillingByPaymentStatus from "./scenes/billing/indexByPaymentStatus";
import BillingByPaymentMethod from "./scenes/billing/indexByPaymentMethod";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/skills" element={<ProtectedRoute element={<Skills searchTerm={searchTerm} />} />} />
<Route path="/coaches" element={<ProtectedRoute element={<Coaches searchTerm={searchTerm} />} />} />
<Route path="/trainingprogrambuilder" element={<ProtectedRoute element={<TrainingProgramBuilder searchTerm={searchTerm} />} />} />
<Route path="/contentlibrary" element={<ProtectedRoute element={<ContentLibrary searchTerm={searchTerm} />} />} />
<Route path="/clients" element={<ProtectedRoute element={<Clients searchTerm={searchTerm} />} />} />
<Route path="/coachingsessions" element={<ProtectedRoute element={<CoachingSessions searchTerm={searchTerm} />} />} />
<Route path="/coachingsessions/list" element={<ProtectedRoute element={<CoachingSessions searchTerm={searchTerm} />} />} />
<Route path="/coachingsessions/status" element={<ProtectedRoute element={<CoachingSessionsByStatus searchTerm={searchTerm} />} />} />
<Route path="/coachingsessions/frequency" element={<ProtectedRoute element={<CoachingSessionsByFrequency searchTerm={searchTerm} />} />} />
<Route path="/tasks" element={<ProtectedRoute element={<Tasks searchTerm={searchTerm} />} />} />
<Route path="/tasks/list" element={<ProtectedRoute element={<Tasks searchTerm={searchTerm} />} />} />
<Route path="/tasks/status" element={<ProtectedRoute element={<TasksByStatus searchTerm={searchTerm} />} />} />
<Route path="/tasks/priority" element={<ProtectedRoute element={<TasksByPriority searchTerm={searchTerm} />} />} />
<Route path="/goalsettingandtracking" element={<ProtectedRoute element={<GoalSettingAndTracking searchTerm={searchTerm} />} />} />
<Route path="/goalsettingandtracking/list" element={<ProtectedRoute element={<GoalSettingAndTracking searchTerm={searchTerm} />} />} />
<Route path="/goalsettingandtracking/status" element={<ProtectedRoute element={<GoalSettingAndTrackingByStatus searchTerm={searchTerm} />} />} />
<Route path="/goalsettingandtracking/priority" element={<ProtectedRoute element={<GoalSettingAndTrackingByPriority searchTerm={searchTerm} />} />} />
<Route path="/coachperformancetracking" element={<ProtectedRoute element={<CoachPerformanceTracking searchTerm={searchTerm} />} />} />
<Route path="/coachperformancetracking/list" element={<ProtectedRoute element={<CoachPerformanceTracking searchTerm={searchTerm} />} />} />
<Route path="/billing" element={<ProtectedRoute element={<Billing searchTerm={searchTerm} />} />} />
<Route path="/billing/list" element={<ProtectedRoute element={<Billing searchTerm={searchTerm} />} />} />
<Route path="/billing/paymentstatus" element={<ProtectedRoute element={<BillingByPaymentStatus searchTerm={searchTerm} />} />} />
<Route path="/billing/paymentmethod" element={<ProtectedRoute element={<BillingByPaymentMethod searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
